import { ContactLinks } from '@components/ContactLinks';

function ContactDetails(): JSX.Element {
  return <ContactLinks orientation="vertical" parent="ContactDetails" />;
}

export default ContactDetails;
